import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import UI_CUSTOMER_DETAILS_PAGE_QUERY from '@atlassian/jira-servicedesk-customer-details/src/ui/__generated__/CustomerDetailsPageQuery$parameters';
import type { CustomerDetailsPageQuery } from '@atlassian/jira-servicedesk-customer-details/src/ui/__generated__/CustomerDetailsPageQuery.graphql';

export const CustomerDetailsPageQueryResource = createRelayResource<CustomerDetailsPageQuery>({
	type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: UI_CUSTOMER_DETAILS_PAGE_QUERY,
		variables: {
			accountId: String(match.params.customerId),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
